// utils.js

export const toPolarCoordinates = (x, y) => {
    const r = Math.sqrt(x ** 2 + y ** 2);
    let phi = Math.atan2(y, x) * (180 / Math.PI); // Convert to degrees
    if (phi < 0) {
        phi += 360;
    }
    return { r, phi };
};

export const getIndexFromPhi = (phi, Ndir) => {
    const angleShift = 360 / Ndir;
    const roundedPhi = Math.round(phi / angleShift) * angleShift;
    let index = Math.round(roundedPhi / angleShift) + 1;
    if (index > Ndir) index = 1; // Ensure index is within [1, 24]
    return index;
};

export const hannwindow = (size) => {
    const window = new Float32Array(size);
    for (let i = 0; i < size; i++) {
        window[i] = 0.5 * (1 - Math.cos((2 * Math.PI * i) / (size - 1)));
    }
    return window;
}

export const rescale_values = (val, a, b, c, d) => {
    return ((d - c) / (b - a)) * (val - a) + c;
}

// wavesurfer RecordPlugin は getUserMedia に deviceId しか渡せず、AGC 等の音声処理を
// 指定できない。稼働中トラックへの applyConstraints では AGC が確実に無効化できないため、
// 録音の getUserMedia 呼び出しの間だけ getUserMedia をラップして音声制約を注入する。
// 使い方: await runWithAudioConstraints(extraAudioConstraints, () => record.startRecording(...))
export const runWithAudioConstraints = async (extraAudioConstraints, fn) => {
    const md = navigator.mediaDevices;
    const original = md.getUserMedia.bind(md);
    md.getUserMedia = (constraints) => {
        if (constraints && constraints.audio) {
            const base = typeof constraints.audio === 'object' ? { ...constraints.audio } : {};
            // deviceId は exact 指定にして、選択デバイスを確実に使う（ideal だと
            // Chrome のサイト設定（アドレスバーのマイク）に上書きされ同期しないため）。
            if (typeof base.deviceId === 'string' && base.deviceId) {
                base.deviceId = { exact: base.deviceId };
            }
            constraints = { ...constraints, audio: { ...base, ...extraAudioConstraints } };
        }
        return original(constraints);
    };
    try {
        return await fn();
    } finally {
        // 元のプロトタイプメソッドへ戻す（他所の録音・通話に影響させない）
        delete md.getUserMedia;
    }
};

export const bufferToWave = (abuffer) => {
    const numOfChan = abuffer.numberOfChannels;
    const length = abuffer.length * numOfChan * 2 + 44;
    const buffer = new ArrayBuffer(length);
    const view = new DataView(buffer);
    const channels = [];
    let pos = 0;

    // RIFF ヘッダー
    setUint32(0x46464952); // "RIFF"
    setUint32(length - 8); // ファイルサイズ - 8
    setUint32(0x45564157); // "WAVE"

    // fmt サブチャンク
    setUint32(0x20746d66); // "fmt "
    setUint32(16); // PCM
    setUint16(1); // フォーマット
    setUint16(numOfChan);
    setUint32(abuffer.sampleRate);
    setUint32(abuffer.sampleRate * 2 * numOfChan);
    setUint16(numOfChan * 2);
    setUint16(16);

    // data サブチャンク
    setUint32(0x61746164); // "data"
    setUint32(length - pos - 4);

    // オーディオデータ
    for (let i = 0; i < abuffer.length; i++) {
        for (let channel = 0; channel < numOfChan; channel++) {
            const sample = abuffer.getChannelData(channel)[i] * 0x7fff;
            view.setInt16(pos, sample, true);
            pos += 2;
        }
    }

    return new Blob([buffer], { type: 'audio/wav' });

    function setUint16(data) {
        view.setUint16(pos, data, true);
        pos += 2;
    }

    function setUint32(data) {
        view.setUint32(pos, data, true);
        pos += 4;
    }
};